import {put,takeLatest,call} from 'redux-saga/effects';
import * as promotionService from "../../../../services/promotionService.js";
import {
    GET_PROMOTIONS,
    GET_PROMOTIONS_SUCCESS,
    GET_PROMOTIONS_ERROR
}
    from "../../../actions/menu/promotions";

function* getPromotionsSaga(action) {
    try {
        const data=yield call(promotionService.GetPromotions,action.payload)
        yield put({
            type: GET_PROMOTIONS_SUCCESS,
            payload: data
        });

    } catch(error) {
        yield put({
            type: GET_PROMOTIONS_ERROR,error: error.data
        });
    }
}


export function* getPromotionsSagaWatcher() {
    yield takeLatest(GET_PROMOTIONS,getPromotionsSaga);
}